export default {
  ctaText: "Let's distribute",
  sidePanelSubtitle1: "Load each truck and select destination.",
  sidePanelSubtitle2: "Slide the product to set the quantity.",
  sidePanelSubtitle3: "You still have items to load onto trucks.",
  sidePanelSubtitle4: "Define the locations of each truck.",
  sidePanelSubtitle5: "Trucks can already start distributing.",
  sidePanelTitle: "Start distribution!",
  title: "Drag & drop items into the trucks"
};
